import { Component, Output, EventEmitter } from "@angular/core";
import { ConsentService } from "src/app/_services/consent.service";
import { RouterLink } from "@angular/router";
import { MatButton } from "@angular/material/button";

@Component({
    selector: 'instant-consent',
    templateUrl: './instant-consent.component.html',
    imports: [RouterLink, MatButton],
})
export class InstantConsent {
    
  @Output() onAccept = new EventEmitter<void>();
  @Output() onDeny = new EventEmitter<void>();
  
  customizeSelection: boolean = false;
  
  constructor(
    private consentService: ConsentService
    ) {
  }

  accept() {
    this.consentService.grantConsent();
    this.onAccept.emit();
  }
  
  deny() {
    this.consentService.denyConsent();
    this.onDeny.emit();
  }
}
